import loadable from "@loadable/component";

const OverviewComponent = loadable(
  () => import("../components/Overview") as unknown as React.ReactElement
);

const Fleet = () => {
  return <OverviewComponent />;
};

export default Fleet;
